class LoyaltyRewardTiers extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'content']
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    if (this?.els?.trigger?.exists) {
      this.els.trigger.elements.forEach(triggerEl => {
        this.listeners.add(triggerEl, `click`, this.handleTrigger)
      })
    }
  }

  handleTrigger (event) {
    const datasetId = event.target.closest(this.els.trigger.selector).dataset.id

    this.els.content.elements.forEach(contentEl => {
      contentEl.setAttribute(
        'aria-expanded',
        contentEl.dataset.id === datasetId,
      )
    })

    this.els.trigger.elements.forEach(triggerEl => {
      triggerEl.setAttribute('aria-pressed', triggerEl.dataset.id === datasetId)
    })
  }
}

if (!customElements.get('loyalty-reward-tiers')) {
  customElements.define('loyalty-reward-tiers', LoyaltyRewardTiers)
}
